module.exports = __webpack_public_path__ + "img/panela-polishop.fbbbd64e.png";